import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, CardTitle, Badge, Row, Col, Button } from 'reactstrap';
import { User, Mail, Shield, Building2, Phone, UserCircle, Briefcase } from 'lucide-react';
import { changePassword, getUserProfile } from '../../Api/ApiUrlConst';

interface ProfileViewProps {
  name: string;
  email: string;
  role: string;
  department: string;
  gender: string;
  phoneNumber: string;
}

const ProfileViewComponents: React.FC<ProfileViewProps> = ({
  name, email, role, department, gender, phoneNumber
}) => {
  const profileFields = [
    { label: 'Full Name', value: name, icon: User },
    { label: 'Email Address', value: email, icon: Mail },
    { label: 'Gender', value: gender, icon: UserCircle },
     { label: 'Phone Number', value: phoneNumber, icon: Phone },
  ];


  const getRoleBadgeColor = (role: string) => {
    switch (role) {
      case 'Admin': return 'danger';
      case 'ProjectManager': return 'primary';
      case 'TeamLeader': return 'info';
      default: return 'secondary';
    }
  };

  //   const toggleTab = (tab: string) => {
  //   if (activeTab !== tab) setActiveTab(tab);
  // };

   

  return (
    

    <div className="d-grid gap-4">
     
      <Card className="shadow-sm rounded-4 border-0">
  <CardHeader className="d-flex align-items-center gap-3 bg-white border-bottom-0">
    <div className="p-3 rounded-circle bg-primary bg-opacity-10 d-flex align-items-center justify-content-center" style={{ width: '48px', height: '48px' }}>
      <Briefcase className="text-primary" />
    </div>
    <div>
      <CardTitle tag="h3" className="mb-0 fw-bold text-dark">User Information</CardTitle>
      <small className="text-muted">Manage your professional details and preferences</small>
    </div>
  </CardHeader>

  <CardBody className="pt-0">
   

    {/* Role and Department Section */}
    <Row className="gy-3">
      <Col md="6">
        <div className="d-flex align-items-center gap-3 p-3 rounded-4 bg-light shadow-sm">
          <div className="p-2 rounded-circle bg-primary bg-opacity-10 d-flex align-items-center justify-content-center">
            <Shield className="text-primary" />
          </div>
          <div>
            <p className="text-muted mb-1 fw-semibold small">Role</p>
            <Badge color={getRoleBadgeColor(role)} className="text-capitalize">{role}</Badge>
          </div>
        </div>
      </Col>
      <Col md="6">
        <div className="d-flex align-items-center gap-3 p-3 rounded-4 bg-light shadow-sm">
          <div className="p-2 rounded-circle bg-primary bg-opacity-10 d-flex align-items-center justify-content-center">
            <Building2 className="text-primary" />
          </div>
          <div>
            <p className="text-muted mb-1 fw-semibold small">Department</p>
            <p className="fw-bold text-dark mb-0">{department}</p>
          </div>
        </div>
      </Col>
    </Row>
  </CardBody>
</Card>


      <Row className="gy-4">
  {profileFields.map((field, index) => {
    const IconComponent = field.icon;
    return (
      <Col md="6" key={index}>
        <Card className="shadow-sm border-0 rounded-4 h-100">
          <CardBody className="p-4">
            <div className="d-flex align-items-start gap-3">
              {/* Icon box */}
              <div className="p-3 rounded-circle bg-primary bg-opacity-10 d-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }}>
                <IconComponent className="text-primary fs-5" />
              </div>

              {/* Content */}
              <div className="flex-grow-1">
                <p className="mb-1 text-muted fw-semibold small text-uppercase">{field.label}</p>
                <p className="mb-0 h5 fw-bold text-dark" style={{ wordBreak: 'break-word' }}>
                  {field.value || <span className="text-muted fst-italic">Not provided</span>}
                </p>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  })}
</Row>

    </div>
  );
};

export default ProfileViewComponents;